//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
// import { withStyles } from '@material-ui/core/styles';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { getDateFormatOptions } from '../lovHelper';
import { PLACEHOLDER_FIELD_DATE_FORMAT } from '../placeholderHelper';
import AfitdAutocompleteLite from './AfitdAutocompleteLite';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _find from 'lodash/find';
// import _remove from 'lodash/remove';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
// const useStyles = makeStyles(theme => ({
// }));

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const dateFormatLov = getDateFormatOptions();

const getOptionLabel = option => {
    const selectedOption = typeof option === 'string' ? _find(dateFormatLov, o => o.code === option) : option;
    return selectedOption?.description;
};

const renderOption = (option, { selected }) => {
    return option.description;
};

const getOptionSelected = (option, value) => {
    return typeof value === 'string' ? option.code === value : option.code === value?.code;
};

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const AfitdDateFormatAutocomplete = props => {
    const { ...otherProps } = props;

    return (
        <AfitdAutocompleteLite
            placeholder={PLACEHOLDER_FIELD_DATE_FORMAT}
            {...otherProps}
            options={dateFormatLov}
            getOptionLabel={getOptionLabel}
            renderOption={renderOption}
            getOptionSelected={getOptionSelected}
        />
    );
};

export default AfitdDateFormatAutocomplete;
